module.exports = __webpack_public_path__ + "img/13-tyyneys.fb0f132d.jpg";